import React from 'react';
import './Card.css';
import { getCardById } from '../../data/cards';

const Card = ({ 
  cardId, 
  revealed = true, 
  selectable = false, 
  selected = false,
  onClick = null 
}) => {
  const card = cardId ? getCardById(cardId) : null;
  const handleClick = () => {
    if (onClick && selectable) {
      onClick(cardId);
    }
  };

  const cardClasses = [
    'game-card',
    selectable ? 'game-card--selectable' : '',
    selected ? 'game-card--selected' : '',
    !revealed ? 'game-card--hidden' : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClasses} onClick={handleClick}>
      {revealed && card ? (
        <>
          <div className="game-card__header">
            <h3 className="game-card__name">{card.name}</h3>
            <div className={`game-card__team game-card__team--${card.team}`}>
              {card.team === 'werewolf' && 'Kurt Adam'}
              {card.team === 'villager' && 'Köylü'}
              {card.team === 'tanner' && 'Düzenbaz'}
            </div>
          </div>
          <div className="game-card__image-container">
            {card.image ? (
              <img 
                src={card.image} 
                alt={card.name}
                className="game-card__image"
              />
            ) : (
              <div className="game-card__placeholder">
                {card.name.charAt(0)}
              </div>
            )}
          </div>
          <div className="game-card__description">
            {card.description}
          </div>
        </>
      ) : (
        <div className="game-card__back">
          <div className="game-card__back-logo">FG</div>
        </div>
      )}
    </div>
  );
};

export default Card;
